import { render } from "./App.vue?vue&type=template&id=15e4ed2f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/isaias/Developer/Trayectics/Trayectics-Questions/trayectics_questions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__